
import React from "react";
import styles from "../css/PlayerDetails.module.css";

const PlayerDetails = ({ player, onBack }) => {
  const stats = player.statistics[0];

  return (
    <div className={styles.container}>
      {/* Back Button */}
      <button onClick={onBack} className={styles.backButton}>
        ← Back
      </button>

      {/* Card Container */}
      <div className={styles.card}>
        {/* Player Image */}
        <div className={styles.imageWrapper}>
          <img
            src={player.player.photo}
            alt={player.player.name}
            className={styles.playerImage}
          />
        </div>

        {/* Player Info */}
        <div className={styles.infoSection}>
          <h2 className={styles.playerName}>{player.player.name}</h2>
          <p className={styles.position}>{stats.games.position}</p>
          <p className={styles.bio}>
            {player.player.name} is a {player.player.age}-year-old footballer from{" "}
            {player.player.nationality}, playing for{" "}
            <span className={styles.bold}>{stats.team.name}</span> in the{" "}
            <span className={styles.bold}>{stats.league.name}</span>. He has appeared in{" "}
            {stats.games.appearences} matches, scoring {stats.goals.total} goals and assisting{" "}
            {stats.goals.assists} times.
          </p>
        </div>

        {/* Stats Footer */}
        <div className={styles.statsSection}>
          <div className={styles.statBlock}>
            <p className={styles.statLabel}>Age</p>
            <p className={styles.statValue}>{player.player.age}</p>
          </div>
          <div className={styles.statBlock}>
            <p className={styles.statLabel}>Height</p>
            <p className={styles.statValue}>{player.player.height || "N/A"}</p>
          </div>
          <div className={styles.statBlock}>
            <p className={styles.statLabel}>Rating</p>
            <p className={styles.statValue}>{stats.games.rating || "N/A"}</p>
          </div>
          <div className={styles.statBlock}>
            <p className={styles.statLabel}>Matches</p>
            <p className={styles.statValue}>{stats.games.appearences || 0}</p>
          </div>
          <div className={styles.statBlock}>
            <p className={styles.statLabel}>Goals</p>
            <p className={styles.statValue}>{stats.goals.total || 0}</p>
          </div>
          <div className={styles.statBlock}>
            <p className={styles.statLabel}>Assists</p>
            <p className={styles.statValue}>{stats.goals.assists || 0}</p>
          </div>
        </div> 
      </div>
    </div>
  );
};

export default PlayerDetails;
